/**
 * A custom directive to handle whois_phone country code changes.
 *
 * TODO: read http://stackoverflow.com/questions/14049480/what-are-the-nuances-of-scope-prototypal-prototypical-inheritance-in-angularjs
 */
App.directive('ngWhoisPhoneFilter', ['whoisHelper', 'formHelper', '$rootScope', function(whoisHelper, formHelper, $rootScope) {
    return {
        require: 'ngModel',
        scope: '=',
        link: function(scope, elem, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            void 0;
            void 0;

            /**
             * Watch out for keypress.
             */
            elem.on('keypress', function(evt) {
                void 0;

                scope.$apply(function() {
                    // enforce country code
                    whoisHelper.enforceCountryCode($rootScope, ngModel, elem, evt);
                });
            });

            elem.on('keyup', function(evt) {
                void 0;
                void 0;

                scope.$apply(function() {
                    // enforce country code
                    whoisHelper.enforceCountryCode($rootScope, ngModel, elem, evt);

                    // enforce numbers only
                    if ($rootScope.formData.whois_phone.match(/[^\d\+\s\-]/g) != null) {
                    	$rootScope.formData.whois_phone = $rootScope.formData.whois_phone.substr(0, $rootScope.formData.whois_phone.length - 2);
                    }

                    // validate overall text
                    whoisHelper.validateText($rootScope, ngModel, elem, evt)
                });
            });

            // initialize placeholder
            whoisHelper.setWhoisCountryCode($rootScope, ngModel);
        }
    }
}]);